import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Benefício',
  path: '/pessoal/pestipobeneficio',
  name: 'pestipobeneficio',
  component: () => import('@/views/pessoal/pestipobeneficio/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.BENEFICIOSNOVO_MENU_1400700999],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Benefício',
  path: '/pessoal/pestipobeneficio/cadastro/:id?',
  parent: 'pestipobeneficio',
  name: 'pestipobeneficio_create',
  component: () => import('@/views/pessoal/pestipobeneficio/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.BENEFICIOSNOVO_MENU_1400700999],
  },
  goesToMenu: true,
 },
]
